
import React from 'react';
import {  MaterialTable } from '../../../components';
import {useGlobalState} from '../../../state';
import { formatDateOnly } from '../../../common/functions';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { Grid, Chip } from '@material-ui/core';
import Mobile from './mobile';
import { minChipLabel } from '../../../views/FeedFormulation/utils/constants';
import EnergyTooltip from '../../../views/Purchase/components/materialTypeComponents/EnergyTooltip';
export default function SaleMaterial({
    saleMaterials,
    actions,
    classes,
    onSaleEdit,
    onDelete
}){
    const [{user}] = useGlobalState();

    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true
    });
    const amountObj = {
        style: "currency",
        currency: user.currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }

    const fSaleMaterial = formatSaleMaterials();

    function formatSaleMaterials(){
        let tArray = [];
        for(var i in saleMaterials){
            var item = saleMaterials[i];
            // calculate total amount of all materials in sale
            const totalAmount = item.saleMaterials.reduce((a,b) => {
                return a + b.billValue;
            },0);
            var nObj = {
                farmName: item.saleMaterials[0].farmName.String,
                totalAmount: totalAmount,
                ...item,
            };
            nObj['sID'] =  nObj.id; // temp sale `id`
            nObj['id'] = item.saleMaterials[0].saleID;
            tArray.push(nObj);
        }
        return tArray;
    }


    

    return(
        <MaterialTable
                columns={[
                    { title: 'id', field: 'id', hidden: true },
                    { title: 'No', field: 'displayId', defaultSort: 'desc', hidden:!isDesktop },
                    {
                        title: 'Sale Details',
                        field: 'saleDetails',
                        hidden: isDesktop, // This column will only show on mobile
                        render: rowData => (
                            <Mobile 
                                data={rowData}
                                onEdit={() => onSaleEdit(rowData)}
                                onDelete={() => onDelete(rowData)}
                                amountObj={amountObj}
                            />
                        ),
                        customFilterAndSearch: (term, rowData) => {
                            return rowData?.saleMaterials?.some(material =>
                                material?.materialName.toLowerCase().includes(term.toLowerCase()) || material?.farmName.String.toLowerCase().includes(term.toLowerCase())
                            );
                        },
                    },
                    {
                    title: 'Date', field: 'date', type: 'datetime', hidden:!isDesktop,
                    cellStyle: { textAlign: 'center' }, headerStyle: { textAlign: 'center' },
                    editable: 'never',
                    render: rowData => {
                        return <span>{formatDateOnly(rowData.date)}</span>
                    }
                    },
                    {
                        title: 'Farm Name', field: 'farmName', editable: 'never', hidden:!isDesktop,
                        render: (rowData) => { return <span>{rowData.farmName}</span> }
                    },
                   {
                        title: 'Material Name',
                        field: 'materialName',
                        editable: 'never',
                        hidden: !isDesktop,
                        customFilterAndSearch: (term, rowData) => {
                            return rowData?.saleMaterials?.some(material =>
                                material?.materialName.toLowerCase().includes(term.toLowerCase())
                            );
                        },
                        render: (rowData) => (
                            <Grid container spacing={1} wrap='nowrap'>
                                {rowData?.saleMaterials?.map((material, index) => {
                                    if(index < minChipLabel){
                                        return (

                                            <Grid item key={index}>
                                                <Chip
                                                    label={material.materialName}
                                                    color="primary"
                                                    size='small'
                                                />
                                            </Grid>
                                        )
                                    }
                                    return null;
                                })}
                                {
                                    rowData?.saleMaterials?.length > minChipLabel ?
                                <EnergyTooltip 
                                    arrow={true}
                                    title = {
                                        <Grid container spacing={1}>
                                            {rowData?.saleMaterials?.map((material, index) => {
                                                if (index >= minChipLabel){

                                                    return (
            
                                                        <Grid item key={index}>
                                                            <Chip
                                                                label={material.materialName}
                                                                color="primary"
                                                                size='small'
                                                            />
                                                        </Grid>
                                                    )
                                                }
                                                return null;
                                                
                                            })}
                                        </Grid>
                                    }
                                    >
                                    <Grid item>
                                        <Chip size="small" color="primary" label={`+ ${rowData?.saleMaterials.length - minChipLabel}`} />
                                    </Grid>
                                </EnergyTooltip> :""
                                }

                            </Grid>
                        )
                    },
                    {
                        title: 'Total amount', field: 'totalAmount', editable: 'never', hidden:!isDesktop,
                        render: (rowData) => {
                            return <span>{(rowData.totalAmount).toLocaleString(user.locales,amountObj)}</span>
                        },
                    },
                ]}
                
                data={fSaleMaterial || []}
                options={{
                    actionsColumnIndex: -1,
                    search: true,
                    showTitle: true,
    
                    toolbar: true,
                }}
                //style={{boxShadow: 'unset'}}
                actions={isDesktop ? actions : []}
                title='Sales'
            />
    );
};